import * as Dialog from "@radix-ui/react-dialog";
import {
  formatZonedDateTime,
  getMaxTime,
  ZonedDateTime,
} from "@sa-nu/shared-utils/date";
import type { ReactNode } from "react";

import { useSnackbar } from "../../../_contexts/snackbar";

export function ReservationInvitationDialog({
  invitationUrl,
  tentativeDeadline,
  open,
  onOpenChange,
  additionalContent,
}: {
  invitationUrl: string;
  tentativeDeadline: ZonedDateTime;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  additionalContent?: ReactNode;
}) {
  const showSnackBar = useSnackbar();
  const deadlineString =
    ZonedDateTime.compare(tentativeDeadline, getMaxTime()) < 0 &&
    formatZonedDateTime(tentativeDeadline, {
      withDayOfWeek: true,
    });

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="sd-overlay">
          <Dialog.Content
            className="sd-content w-[315px] space-y-[50px] p-[30px] md:w-[690px]"
            onInteractOutside={(e) => e.preventDefault()}
            onEscapeKeyDown={(e) => e.preventDefault()}
            onPointerDownOutside={(e) => e.preventDefault()}
          >
            <Dialog.Title className="font-bold">
              予約招待URLを発行しました
            </Dialog.Title>
            <Dialog.Description className="space-y-4">
              <div className="text-[13px] leading-6">
                仮予約を作成しました。ご友人が下記のURLからWebページにログインし、宿泊者情報とお支払い情報を登録すると、予約が確定します。こちらのURLを招待したい相手に共有してください。
              </div>
              <div className="border-sbeige flex flex-col space-y-4 border p-6 md:flex-row md:items-center md:space-y-0 md:space-x-4">
                <div className="break-all">{invitationUrl}</div>
                <div className="md:flex-auto">
                  <button
                    data-analytics-id="reservation_form_clicked_invitation_copy"
                    className="old-btn-orange h-[30px] w-full rounded-full px-8 text-[12px] font-bold whitespace-nowrap"
                    onClick={() => {
                      navigator.clipboard.writeText(invitationUrl);
                      showSnackBar({ message: "URL をコピーしました" });
                    }}
                  >
                    URL をコピー
                  </button>
                </div>
              </div>
              {deadlineString && (
                <div className="text-sorange text-[13px]">
                  {deadlineString}{" "}
                  までに手続きが完了しない場合、仮予約は自動キャンセルとなりますのでお気をつけください。
                </div>
              )}
            </Dialog.Description>
            {additionalContent}
            <Dialog.Close className="btn-secondary h-[30px] w-full self-end md:h-[48px] md:w-[190px]">
              閉じる
            </Dialog.Close>
          </Dialog.Content>
        </Dialog.Overlay>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
